
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apipages/upload/videos",
      function () {
        return require("private-next-pages/apipages/upload/videos/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apipages/upload/videos"])
      });
    }
  